import React from 'react'
import { Box, Button, IconButton, Link, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '@mui/icons-material/Delete'
import axios from 'axios'
import T from 'prop-types'

export default function PartnerDocumentsItem({
  index,
  type,
  documents,
  onButtonClick,
  onDelete,
  readOnly,
}) {
  const { t } = useTranslation()

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography width="250px">{`${index}. ${t(
          // eslint-disable-next-line sonarjs/no-nested-template-literals
          `partnerDocuments.types.${type}.title`
        )}`}</Typography>
        {!documents && (
          <>
            <Button
              variant="contained"
              onClick={() => onButtonClick(type)}
              disabled={readOnly}
            >
              {t(`partnerDocuments.updateButton`)}
            </Button>
          </>
        )}
        {documents && (
          <>
            <IconButton
              data-testid="options-action"
              aria-label="Delete"
              onClick={() => onDelete(type)}
              disabled={readOnly}
            >
              <DeleteIcon />
            </IconButton>
            <Stack direction="row" spacing={6} alignItems="center">
              {documents.map(
                (document, index) =>
                  document && (
                    <Link
                      key={`${type}_document_${index}`}
                      component={Box}
                      variant="body2"
                      onClick={async () => {
                        const result = await axios.get(document)
                        window.location = result.data?.body?.signedUrl
                      }}
                      color="primary"
                      sx={{ cursor: 'pointer' }}
                    >
                      {t(
                        `partnerDocuments.types.${type}.document${
                          index + 1
                        }.label`
                      )}
                    </Link>
                  )
              )}
            </Stack>
          </>
        )}
      </Stack>
    </>
  )
}

PartnerDocumentsItem.propTypes = {
  index: T.number.isRequired,
  type: T.string.isRequired,
  documents: T.array,
  onButtonClick: T.func,
  onDelete: T.func,
  readOnly: T.bool,
}
